const baseName ='/notification'
const create ='/create'
const view ='/view'
module.exports = {
    createNotification:baseName+create,
    viewNotification:baseName+view,
}